<div>
  <div class="notifications-menu" *ngFor="let notification of notificationLists; let i=index">
    <a href="javascript:void(0)" class="dropdown-item d-flex pointer"
      [ngClass]="notification?.isRead == 0 ? 'unRead' : ''"
      (click)="openNotificationReadPopup(notification);$event.stopPropagation()">
      <div>
        <h6 class="notification-label" [ngClass]="usedFor == 'header' ? 'h-title' : 'v-title'"> {{notification?.title ||
          "--"}} </h6>
        <span class="notification-subtext fs-12"
          [ngClass]="usedFor == 'header' ? 'h-description' : 'v-description'">{{notification?.message || "--"}}</span>
      </div>
      <div class="actionBtn">
        <div *ngIf="notification?.type != 10 && notification?.type != 100" class="arrow"
          (click)="redirectNotification(notification);$event.stopPropagation()"></div>
        <div *ngIf="notification?.showApproveEditRequest == 1"
          [ngStyle]="{'margin-right': notification?.type != 10 ? '30px' : '' }">
          <div class="iconTick bg-active ml-1" ngbTooltip="Approve" placement="left"
            (click)="actionPopup('approve', notification);$event.stopPropagation()"></div>
          <div class="iconCross bg-cancelled ml-1" ngbTooltip="Decline" placement="left"
            (click)="actionPopup('decline', notification);$event.stopPropagation()"></div>
        </div>
      </div>
      <span class="time ms-auto" [ngStyle]="usedFor == 'header' ? {'left': '40px;'} : {'left': '0'}">
        {{dateInMilisecond(notification?.createdAt) | dateAgo}}
      </span>
    </a>
  </div>
  <div class="notifications-menu noData" 
    [ngStyle]="usedFor == 'header' ? {'padding': '100px;'} : {'padding': '200px'}"
    *ngIf="notificationLists?.length == 0">No record found!
  </div>
</div>